import { CreateGenresDetail } from '@bpm-web-app/components/pages';

export default CreateGenresDetail;
